import { AppRoute, ConfigSettingsService, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';

@Injectable()
export class ValidateNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor(private readonly configService: ConfigSettingsService) {
    super('VALIDATE', 'menu.label.validation', AppRoute.EmailValidation, 'a11y.link.validierung');
  }

  public guard(): boolean {
    return this.configService.appSettings.supportedOAuthGrants.has('password');
  }
}
